<template>
  <Component :is="overlay" v-if="overlay" @closed="handleClosed" />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import type { Component } from 'vue';
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import type { ApiTabValueType } from '../types';
import useApiRoutes from '../useApiRoutes';
import useApiTabs from '../useApiTabs';

import ApiFilterDrawer from './ApiFilterDrawer.vue';
import ApiIntegrationCreateModal from './ApiIntegrationCreateModal.vue';
import ApiKeyCreateModal from './ApiKeyCreateModal.vue';
import ApiWebhookCreateModal from './ApiWebhookCreateModal.vue';

const CREATE_COMPONENTS: Partial<Record<ApiTabValueType, Component>> = {
  webhooks: ApiWebhookCreateModal,
  integrations: ApiIntegrationCreateModal,
  filters: ApiFilterDrawer,
  keys: ApiKeyCreateModal,
};

const route = useRoute();
const { getTabByValue } = useApiTabs();
const { closeOverlay } = useApiRoutes();

const currentTab = computed(() => getTabByValue(route.params.tab as string));
const overlay = computed(
  () => currentTab.value && CREATE_COMPONENTS[currentTab.value.value],
);

function handleClosed() {
  if (currentTab.value) closeOverlay(currentTab.value.value);
}

onMounted(() => {
  if (!overlay.value) handleClosed();
});

useHead({
  title: computed(() => `Create - ${currentTab.value?.name} - API - Crossbeam`),
});
</script>
